import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Global brand tokens
import './styles/variables.css';

// ScrollReveal side effects
import './scrollreveal.js';

// i18n
import { i18n } from './i18n';

createApp(App).use(router).use(i18n).mount('#app');
